"use client";

import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

interface StreetHouseFieldsProps {
  street: string;
  housenumber: string;
  errors: { street: string; housenumber: string };
  disabled?: boolean;
  onStreetChange: (v: string) => void;
  onHousenumberChange: (v: string) => void;
  streetRef: React.RefObject<HTMLInputElement>;
  housenumberRef: React.RefObject<HTMLInputElement>;
}

const StreetHouseFields: React.FC<StreetHouseFieldsProps> = ({
  street,
  housenumber,
  errors,
  disabled = false,
  onStreetChange,
  onHousenumberChange,
  streetRef,
  housenumberRef,
}) => {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 gap-4">
      <div className="space-y-2 field-row">
        <Label htmlFor="street">{t("contactDetails.street")}</Label>
        <Input
          id="street"
          name="street"
          autoComplete="street-address"
          type="text"
          value={street}
          onChange={(e) => onStreetChange(e.target.value)}
          maxLength={70}
          className={cn(errors.street && "border-destructive focus-visible:ring-destructive")}
          disabled={disabled}
          ref={streetRef}
        />
        {errors.street && <p className="text-sm text-destructive">{errors.street}</p>}
      </div>
      <div className="space-y-2 field-row">
        <Label htmlFor="housenumber">{t("contactDetails.housenumber")}</Label>
        <Input
          id="housenumber"
          name="housenumber"
          type="text"
          value={housenumber}
          onChange={(e) => onHousenumberChange(e.target.value)}
          maxLength={16}
          className={cn(errors.housenumber && "border-destructive focus-visible:ring-destructive")}
          disabled={disabled}
          ref={housenumberRef}
        />
        {errors.housenumber && <p className="text-sm text-destructive">{errors.housenumber}</p>}
      </div>
    </div>
  );
};

export default StreetHouseFields;
